module.exports = __webpack_public_path__ + "static/media/menu-1.8a390a47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/menu-1.svg
// module id = 1186
// module chunks = 0